import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelayAlert = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 44,
	viewBox: "0 0 34 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 18.785,
			cy: 6.5,
			rx: 2.61314,
			ry: 2.5,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 22.9006,
			cy: 31.5,
			rx: 3.65839,
			ry: 3.5,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 18.0893,
			cy: 19.5,
			rx: 12.2221,
			ry: 12.5,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6424 6.30469C22.844 6.30469 28.6819 12.2754 28.6819 19.6407C28.6819 27.0047 22.844 32.974 15.6424 32.974C8.4408 32.9754 2.60547 27.0047 2.60547 19.6407C2.60417 12.2754 8.4408 6.30469 15.6424 6.30469ZM15.6424 8.30469C14.1768 8.28843 12.7226 8.56962 11.364 9.13198C10.0053 9.69435 8.76924 10.5267 7.72724 11.5809C6.68524 12.6351 5.85802 13.8902 5.29345 15.2735C4.72889 16.6569 4.43819 18.141 4.43819 19.64C4.43819 21.139 4.72889 22.6232 5.29345 24.0065C5.85802 25.3898 6.68524 26.6449 7.72724 27.6991C8.76924 28.7533 10.0053 29.5857 11.364 30.1481C12.7226 30.7104 14.1768 30.9916 15.6424 30.9754C18.5611 30.943 21.3494 29.7345 23.4021 27.6122C25.4549 25.4899 26.6062 22.6252 26.6062 19.64C26.6062 16.6548 25.4549 13.7901 23.4021 11.6678C21.3494 9.54557 18.5611 8.33706 15.6424 8.30469ZM15.6424 21.638C17.7687 21.638 19.7621 22.51 21.2235 24.0314C21.3185 24.1239 21.3944 24.235 21.4465 24.3581C21.4987 24.4813 21.5261 24.6139 21.5271 24.7481C21.528 24.8822 21.5026 25.0152 21.4523 25.1392C21.402 25.2631 21.3278 25.3754 21.2341 25.4694C21.1405 25.5633 21.0293 25.6371 20.9072 25.6862C20.7851 25.7353 20.6546 25.7588 20.5235 25.7553C20.3923 25.7517 20.2632 25.7212 20.1438 25.6656C20.0244 25.6099 19.9172 25.5303 19.8286 25.4314C19.2831 24.8621 18.632 24.4101 17.9133 24.1019C17.1946 23.7937 16.423 23.6355 15.6437 23.6367C14.8623 23.6353 14.0886 23.7941 13.3683 24.1038C12.6479 24.4134 11.9956 24.8675 11.4497 25.4394C11.3598 25.5332 11.2528 25.608 11.1346 25.6596C11.0165 25.7111 10.8895 25.7383 10.7611 25.7397C10.6326 25.741 10.5052 25.7165 10.386 25.6675C10.2668 25.6185 10.1583 25.5459 10.0665 25.454C9.97474 25.3621 9.90158 25.2526 9.85119 25.1317C9.80081 25.0109 9.77419 24.8811 9.77286 24.7497C9.77153 24.6184 9.79551 24.488 9.84343 24.3661C9.89136 24.2442 9.96228 24.1332 10.0522 24.0394C10.7801 23.2778 11.6497 22.6729 12.6098 22.2605C13.5699 21.8481 14.6011 21.6364 15.6424 21.638ZM11.7313 15.3074C11.9491 15.3011 12.1659 15.3395 12.369 15.4204C12.572 15.5013 12.7571 15.623 12.9133 15.7783C13.0695 15.9336 13.1937 16.1194 13.2785 16.3247C13.3633 16.5299 13.407 16.7505 13.407 16.9734C13.407 17.1962 13.3633 17.4168 13.2785 17.622C13.1937 17.8273 13.0695 18.0131 12.9133 18.1684C12.7571 18.3237 12.572 18.4454 12.369 18.5263C12.1659 18.6072 11.9491 18.6457 11.7313 18.6394C11.3073 18.6271 10.9046 18.4462 10.6089 18.1351C10.3132 17.824 10.1478 17.4072 10.1478 16.9734C10.1478 16.5395 10.3132 16.1227 10.6089 15.8116C10.9046 15.5005 11.3073 15.3196 11.7313 15.3074ZM19.5535 15.3074C19.7713 15.3011 19.9881 15.3395 20.1911 15.4204C20.3941 15.5013 20.5792 15.623 20.7355 15.7783C20.8917 15.9336 21.0159 16.1194 21.1007 16.3247C21.1855 16.5299 21.2292 16.7505 21.2292 16.9734C21.2292 17.1962 21.1855 17.4168 21.1007 17.622C21.0159 17.8273 20.8917 18.0131 20.7355 18.1684C20.5792 18.3237 20.3941 18.4454 20.1911 18.5263C19.9881 18.6072 19.7713 18.6457 19.5535 18.6394C19.1294 18.6271 18.7268 18.4462 18.4311 18.1351C18.1354 17.824 17.97 17.4072 17.97 16.9734C17.97 16.5395 18.1354 16.1227 18.4311 15.8116C18.7268 15.5005 19.1294 15.3196 19.5535 15.3074Z",
			fill: "#E34C4C"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 31.5415,
			cy: 36.5,
			rx: 2.45942,
			ry: 2.5,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 29.0775,
			cy: 43,
			rx: .983769,
			ry: 1,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24.1595,
			cy: 1,
			rx: .983769,
			ry: 1,
			fill: "#FFE6E6"
		})
	]
});
export default SvgDelayAlert;
